import React, { useEffect } from "react";
import { FileText, Download } from "lucide-react";
import { LAWS } from "../mock";

export default function Regulation() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div>
      <section className="hero-pattern text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <h1 className="font-serif text-3xl sm:text-5xl font-bold mb-4">Laws &amp; Regulation</h1>
          <p className="text-slate-200 max-w-2xl text-lg">
            The legal framework governing securities and capital markets in Sierra Leone.
          </p>
        </div>
      </section>

      <section className="bg-slate-50 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {LAWS.map((l) => (
              <div key={l.title} className="bg-white rounded-xl border border-slate-200 p-6 flex gap-4 hover:border-brand-green hover:shadow-md transition-all">
                <div className="w-12 h-12 rounded-lg bg-[#eaf4ee] flex items-center justify-center shrink-0">
                  <FileText className="text-brand-green" size={24} />
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1.5">
                    <span className="text-xs font-semibold text-brand-navy bg-slate-100 px-2 py-0.5 rounded">{l.type}</span>
                    <span className="text-xs text-slate-400">{l.year}</span>
                  </div>
                  <h3 className="font-serif text-lg font-bold text-brand-navy mb-1.5">{l.title}</h3>
                  <p className="text-sm text-slate-500 leading-relaxed mb-3">{l.desc}</p>
                  <button className="inline-flex items-center gap-1.5 text-sm font-semibold text-brand-green hover:gap-2.5 transition-all">
                    <Download size={15} /> Download PDF
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
